import React, { useEffect } from 'react';
import { ErrorElementProps } from '@urc-ui/components/error-element/types';
import { useRouteError } from 'react-router-dom';
import { ErrorCard } from '@urc-ui/components/error-card';
import { logger } from '@urc-ui/services/logger';

const ErrorElement = (props: ErrorElementProps) => {
  const error = useRouteError();

  useEffect(() => {
    logger.logFatalMessage(`There was an error rendering page ${props.pageId}`, error);
  }, [error]);

  return <ErrorCard />;
};

export { ErrorElement };
export type { ErrorElementProps };
